/** List assets for a KB article. */
export const kbArticleAssetsListSpec = {
    uri: '/kb/article/[article]/assets',
    method: 'GET',
    adminOnly: true,
};
